import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import { Modal, message, Tag } from 'antd';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const columns = utils.columns([
    { key: '$index', label: '序号', width: 75 },
    { key: 'lessonAddress', label: '上课地点' },
    { key: 'employeeCode', label: '教工号', width: 90 },
    { key: 'employeeName', label: '教师', width: 70 },
    { key: 'courseName', label: '课程名称', width: 150 },
    { key: 'classesName', label: '班级名称', width: 120 },
    { key: 'orgName', label: '部门名称', width: 100 },
    // { key: 'employeeOrgName', label: '教师部门', width: 100 },
    { key: 'patrolEmployeeName', label: '巡课人', width: 100 },
    { key: 'lessonNum', label: '节次', width: 60 },
    // { key: 'patrolLessonNum', label: '巡课节次', width: 100 },
    { key: 'weekName', label: '星期', width: 60 },
    // { key: 'patrolWeekNum', label: '巡课周次', width: 100 },
    { key: 'weekNum', label: '周次', width: 80 },
    { key: 'totalStudent', label: '应到人数', width: 80 },
    { key: 'actualStudent', label: '实到人数', width: 80 },
    // {
    //     key: 'submitStatus', label: '提交状态', width: 100, render: (val) => {
    //         if (val === 1) {
    //             return <Tag color='green'>正式提交</Tag>
    //         }
    //     }
    // },
    { key: 'campus', label: '校区', width: 100 },
    { key: 'academicBuilding', label: '教学楼', width: 100 },
    { key: 'floor', label: '楼层/号', width: 100 },
    { key: 'patrolTime', label: '巡课时间', width: 100 },
    { key: 'submitTime', label: '提交时间', width: 100 },
    { key: 'termName', label: '所属学期', width: 100 },

]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    const defaultsParams = {
    };
    let params = []
    if (keywords['sort'] !== '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('patrol/class/result/query?' + params.join('&'), Object.assign(defaultsParams, keywords))
        .then(response => {
            return response.payload.data;
        })
        .then(data => (Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('patrol/class/result/get/' + id, {})
        .then(response => response.payload.data)
        .catch(error => {
            console.log('error');
        });
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('patrol/class/result/insert', data)
        .then(response => {
            return response
        });
}


/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('patrol/class/result/update/' + id, data)
        .then(response => {
            return response
        });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('patrol/class/result/remove', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if (DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if (response.code === 200) {
                        message.success(response.message);
                        DataGrid.refresh();
                    }
                });
            },
            onCancel() { },
            okText: "确认",
            cancelText: "取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'course/plan' + url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if (DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText: "确认",
        });
    } else {
        redirect('/update/' + DataGrid.selections[0]);
    }
}

export default {
    insertURL: '#/course/plan/insert',
    querySearch,
    insert,
    update,
    remove,
    columns,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection,
    querySearchById
}